import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";
import ItemsField from "../../bookmaker-deals/fields/ItemsField";

const DealField = ({
	record,
	data,
	id = get(record, "id", undefined),
	hideLabel = false,
	...props
}) => {
	const translate = useTranslate();
	if (!data) {
		data = {
			[record.id]: record,
		};
	}
	return (
		<React.Fragment>
			{!hideLabel && (
				<Typography variant="overline" style={{ fontWeight: "bold" }}>
					{translate("resources.bookmaker-deals.name", {
						smart_count: get(data[id], "deals", []).length,
					})}
				</Typography>
			)}
			{!!get(data[id], "deals") &&
				get(data[id], "deals").map((deal) => (
					<Typography key={deal.id} variant="h6" style={{ fontWeight: "bold" }}>
						<ItemsField source="items" record={deal} />
					</Typography>
				))}
		</React.Fragment>
	);
};

export default DealField;
